module.exports = __webpack_public_path__ + "img/zzdp-title-icon.5776febe.png";